import HelloModal from 'common/components/hello-modal';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  cancel: {
    id: '',
    description: 'button text in delete rule field modal, when clicked closes the modal',
    defaultMessage: 'Cancel',
  },
});

type Props = {
  header: string | React.ReactNode,
  message: string | React.ReactNode,
  button: string | React.ReactNode,
  callback: () => void,
  onClose: () => void,
}
export default function ConfirmModal(props: Props) {
  const intl = useIntl();

  return (
    <HelloModal
      isOpen={true}
      onRequestClose={props.onClose}
      contentLabel={props.header}
      buttons={[
        {
          type: 'secondary',
          text: intl.formatMessage(messages.cancel),
          onClick: props.onClose,
          'data-qa-ref': 'cancel',
        },
        {
          type: 'delete',
          text: props.button,
          onClick: () => {
            props.callback();
            props.onClose();
          },
          'data-qa-ref': 'delete',
        },
      ]}
    >
      {props.message}
    </HelloModal>
  );
}
